module.exports = __webpack_public_path__ + "static/img/logo.d3e46138.svg";